import { Validators } from '@angular/forms';

import { NoteDetailFormValue } from '../../coaching-note/note-detail-form-value.model';
import {
    CmpsFormField,
    CmpsFormFields,
} from '../../coaching-observation/experimental.form';
import { TranslationKeyMap } from '../coaching-commitment.i18n';

export interface DisputeFormFields extends CmpsFormFields {
    REASON: CmpsFormField;
    COMMENT: CmpsFormField;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DisputeFormFields: DisputeFormFields = {
    REASON: {
        name: 'reason',
        label: '',
        placeholder: TranslationKeyMap._9522_SELECT_DISPUTE_REASON,
        validators: [Validators.required],
        validationMsgs: {
            required:
                TranslationKeyMap._9523_PLEASE_SELECT_DISPUTE_REASON_BEFORE_PROCEEDING,
        },
    },
    COMMENT: {
        name: 'comment',
        label: '',
    },
};

export interface DisputeFormValue {
    reason?: number;
    comment?: NoteDetailFormValue;
}
